import { ReactNode } from 'react'
import { ContentfulMarkdown } from '@utils/contentful/ContentfulMarkdown'
import { FormFieldTooltip } from '@noissue-ui-kit/form/form/FormFieldTooltip'

interface IBriefStepSection {
  label: string
  tooltip: string
  children: ReactNode | ReactNode[]
  description?: string
}

export function BriefStepSection({
  label,
  tooltip,
  children,
  description,
}: IBriefStepSection) {
  return (
    <div className="flex flex-col mb-12 last:mb-0 font-mori">
      <div className="flex flex-wrap items-center">
        <h4 className="text-[14px] leading-none text-acai">{label}</h4>
        {tooltip && (
          <FormFieldTooltip>
            <ContentfulMarkdown
              overrideClass="text-2xl font-normal leading-8 text-boulder"
              overrideStyles={{
                a: ({ children, href }) => (
                  <a
                    className="pointer-events-auto text-pitaya"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {` ${children} `}
                  </a>
                ),
              }}
            >
              {tooltip}
            </ContentfulMarkdown>
          </FormFieldTooltip>
        )}
      </div>

      {description && (
        <p className="mt-2 text-lg text-core-grey-80">{description}</p>
      )}

      <div className="flex w-full mt-5">{children}</div>
    </div>
  )
}
